export const buildSeoPayload = ({ t, pageUrl }) => {
    return {
        title: t.seo.title,
        description: t.seo.description,
        keywords: t.seo.keywords,
        url: pageUrl,
        image: t.seo.image,
        type: t.seo.type,
        canonical: pageUrl,
        faq: t.seo.faq,
        webPage: {
            name: t.seo.webPage.name,
            url: pageUrl,
            description: t.seo.webPage.description,
        },
        breadcrumb: [
            { name: t.seo.breadcrumb.homeName, item: "https://virtalibry.com" },
            { name: t.seo.breadcrumb.pageName, item: pageUrl },
        ],
    };
};